import { Input } from 'antd';

const SearchBox = ({ getText, searchCustomer }: any) => {
  const { Search } = Input;
  const onChangeText: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    getText(e.target.value);
  };

  return (
    <>
      {!searchCustomer && (
        <div className={'seacrh'}>
          <Search
            className="search_input"
            placeholder="Search"
            allowClear
            onChange={onChangeText}
          />
        </div>
      )}

      {searchCustomer && (
        <div className={'searchCustomer'}>
          <Search
            className="search_input"
            placeholder="Search Customer..."
            allowClear
            onChange={onChangeText}
          />
        </div>
      )}
    </>
  );
};

export default SearchBox;
